import React from 'react';
import style from './design.module.scss';
import Link from 'next/link';
import Head from 'next/head';
import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function DesignLanding(props) {

  //Set the window size state to maintain media queries
  const [gridSize, setGridSize] = useState(0)
  
  useEffect (() => {
		const handleGridResize = () => {
      let limit = 0
			if (props.windowSize === "Web") {
        //set column limit
        limit = 4
      } else if (props.windowSize === "Tablet") {
          //set column limit
          limit = 2
      } else {
        //set column limit
        limit = 7
      }

			if (limit !== gridSize) {
				setGridSize(limit)
			}
		}
		
		window.addEventListener('resize', handleGridResize)

		handleGridResize()

		return () => {
			window.removeEventListener('resize', handleGridResize)
		}
  })

  let mainPath = '/e2-engineering-services/electrical-system-design/'
  let linkArr = [
    'System Integration and Design',
    'Generator Control and Protection Systems',
    'Generator Excitation Systems and Voltage Regulators',
    'Sync Motor or Condenser Control and Protection Systems',
  ]
  
  //Handles css grid layout for IE
  let linkElements = []
  let colCount = 1
  let rowCount = 1
  let linkCount = 0

  for (let i = 0; i < linkArr.length; i++) {
    if (props.windowSize !== "Mobile") {
      let classStr = ``

      //Add a right border to every cell that is not the last column in a row
      if (((linkCount + 1) % gridSize) !== 0) {
        classStr += ` ${style.borderRight}`
      }

      //Add a bottom border to every cell that is not in the last row
      if (rowCount < ((Math.floor(linkArr.length / gridSize) + 1) - 1)) {
        classStr += ` ${style.borderBottom}`
      } 

      //Create quick link element
      linkElements[linkCount] = <Link key={"link" + linkCount} href={mainPath + linkArr[linkCount].replace(/\s/g, "-").toLowerCase()}><a className={classStr} style={{msGridRow: rowCount, msGridColumn: colCount}}><span>{linkArr[linkCount]}</span></a></Link>
    } else {
      //Create quick link element
      linkElements[linkCount] = <Link key={"link" + linkCount} href={mainPath + linkArr[linkCount].replace(/\s/g, "-").toLowerCase()}><a style={{msGridRow: rowCount, msGridColumn: colCount}}><span>{linkArr[linkCount]}</span></a></Link>
    }

    //Check if column gridSize has been reached
    if (colCount === gridSize) {
      colCount = 1
      rowCount++
    } else {
      colCount++
    }

    linkCount++
  }

  //Handles style grid by creating the circle elements and changing the columns/rows accordingly (Tablet and Web only)
  let circles = null
  let styleBox1 = null
  let styleBox2 = null
  let styleGrid = null
  let limit = 0

  if (props.windowSize !== "Mobile") {
    limit = 11
    colCount = 1
    rowCount = 1
    circles  = []

    for (let x = 0; x < (9 * 11); x++) {

      //Creating accent circle
      circles[x] = <span key={"span" + x} style={{msGridRow: rowCount, msGridColumn: colCount}}></span>

      if (colCount === limit) {
        colCount = 1
        rowCount++
      } else {
        colCount++
      }
    }

    styleBox1 = <div className={style.styleBoxOne}></div>
    styleBox2 = <div className={style.styleBoxTwo}></div>
    styleGrid = <div className={style.styleGrid}>{circles}</div>
  }
  
  return (
    <div className={style.DesignLanding}>
      <Head>
        <title>Electrical System Design | Basler Services</title>
      </Head>
      <div className={style.breadcrumbNav}>
        <li><Link href={'/e2-engineering-services'}><a><FontAwesomeIcon icon={['fal', 'chevron-left']} /> E&#178; Engineering Services</a></Link></li>
        <span>/</span>
      </div>
      <h3>Electrical System Design</h3>
      <div className={style.quickLinkContainer}>
        {styleBox1}
        {styleBox2}
        {styleGrid}      
        <div className={style.quickLinks}>
          {linkElements}
        </div>
      </div>
      <div className={style.quickInfoSection}>
        <h4>{linkArr[0]}</h4>
        <p>It&#39;s not just about installing a new piece of equipment and setting up the PID Loop, it&#39;s about system integration. Basler Services has experience with all types of generating systems and how to properly interface all of the new and old elements together for a more reliable and efficient system.</p>
        <Link href={mainPath + linkArr[0].replace(/\s/g, "-").toLowerCase()}><a className={`${style.cta} ${style.primaryCta}`}>Learn More <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
      </div>
      <div className={style.quickInfoSection}>
        <h4>{linkArr[1]}</h4>
        <p>Basler Services&#39; Generator Specialist will complete a generator study to determine what is needed to maximize operating efficiency, increase reliability and reduce costs. Our Generator Specialist will provide the direction required to help ensure the viability of systems, equipment and the staff safety.</p>
        <Link href={mainPath + linkArr[1].replace(/\s/g, "-").toLowerCase()}><a className={`${style.cta} ${style.primaryCta}`}>Learn More <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
      </div>
      <div className={style.quickInfoSection}>
        <h4>{linkArr[2]}</h4>
        <p>Features of the new digital static excitation and voltage regulator interface include the data logging (oscillography), sequence of events recording and real-time dynamic system analyzers. These can be set up and accessed easily by a laptop and greatly aid in system testing and troubleshooting of problems, such as those caused by system disturbances. We can now record the performance of the system both before and after any system disturbance.</p>
        <Link href={mainPath + linkArr[2].replace(/\s/g, "-").toLowerCase()}><a className={`${style.cta} ${style.primaryCta}`}>Learn More <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
      </div>
      <div className={style.quickInfoSection}>
        <h4>{linkArr[3]}</h4>
        <p>Our engineers understand the specific requirements associated with synchronous motor control and will develop a complete synchronous motor controller system. This system includes equipment required to safely accelerate the motor and apply the DC voltage to the rotating field at the correct time to insure rapid synchronization while protecting the motor from overload, jam, pull-out and off-frequency conditions.</p>
        <Link href={mainPath + linkArr[3].replace(/\s/g, "-").toLowerCase()}><a className={`${style.cta} ${style.primaryCta}`}>Learn More <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
      </div>
    </div>
  );
}

export default DesignLanding;